import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c32f45f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AccessUv" }
const _hoisted_2 = { style: {"height":"60px","display":"inline-flex","margin":"0 auto"} }
const _hoisted_3 = { style: {"height":"60px","line-height":"60px","text-align":"center","margin-left":"14px"} }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'

import { useStore } from '@/store'
import { toDay } from '@/utils/date-format'
import {initEmptyParam} from "@/hooks/useInitParam";
import localCache from '@/utils/cache'


export default /*#__PURE__*/_defineComponent({
  __name: 'AccessUv',
  setup(__props) {

initEmptyParam()
const store = useStore()
const userInfo = store.state.login.userInfo

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return {title: item.realName, value: item.id};
  })
  const userItem = searchFormConfig.formItems.find((item) => item.field === 'empIds')
  userItem!.options = userOptions;
}
getEmp()

const queryParam = {
  empIds: userInfo.id,
  accessTime: [toDay(), toDay()]
}

store.commit('system/changeQueyryInfo', queryParam)
const resetCb = () => {
  return queryParam
}

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const [pageContentRef, handleResetClick, handleSearchClick] =
  usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "fuboAccessUv",
      onSortChange: handleSortChange
    }, {
      consumer: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 60,
            src: scope.row.consumerHeadImgUrl
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.consumerNickName), 1)
        ])
      ]),
      _: 1
    }, 8, ["contentTableConfig"])
  ]))
}
}

})